import { FunctionComponent } from 'react';

interface WordGuessedProps {
  text: string;
}

export const WordGuessed: FunctionComponent<WordGuessedProps> = ({ text }) => {
  return <div>{text}</div>;
};
